import React from 'react';
import InlineValidationMessage from '../InlineValidationMessage';
import SelectWithLoading from '../SelectWithLoading';
import { itemsPropTypes } from '../commonPropTypes';

const SelectWithValidation = React.createClass({
    propTypes: {
        items: itemsPropTypes
    },
    render: function() {
        const { input, items, label, placeholder, autoFocus, isLoading, loadingError, meta: { touched, error } } = this.props;

        return <div>
            <label>{label}</label>
            <div className="pure-g">
                <div className="pure-u-16-24">
                    <SelectWithLoading items={items ? items.map(x => ({ id: x.id, name: x.value, disabled: x.disabled })) : null} 
                        isLoading={isLoading} value={input.value} autoFocus={autoFocus} onChange={input.onChange} 
                        disabled={input.disabled} placeholder={placeholder} loadingError={loadingError} />
                </div>
            </div>
            <InlineValidationMessage touched={touched} error={error} />
        </div>;
    }
});

export default SelectWithValidation;



// WEBPACK FOOTER //
// ./src/components/common/SelectWithValidation/index.jsx